import i18n from '@/locales'

export const finishes = [
  {
    value: 'GLUED',
    label: i18n.t('glued')
  }
]

export const printModes = [
  {
    value: 'RECTO_VERSO',
    label: i18n.t('recto_verso')
  },
  {
    value: 'RECTO',
    label: i18n.t('recto')
  }
]
